<template>
  <div id="product_filter_index_desktop" class="product_filter_index_desktop">
    <div class="container">
      <div class="form mt-0 px-0" @submit.prevent="search" :class="hasActiveElement ? 'has_active' : ''"
           v-click-outside="disableActiveElement">
        <div class="row">
          <div class="col-12 col-md-12 col-lg-4 col-xl-4 p-0 position-relative">
            <div class="filter-item place" :class="activeElement==='place' ? 'active' : ''">
              <div class="form-group" @click="setActiveElement('place');">
                <label for="city">{{ $t('location') }}</label>
                <input type="text" class="form-control"
                       :placeholder="$t('location-placeholder')" readonly
                       :value="placeObj && placeObj.id ? placeObj.title : (filterData.region && filterData.region.length > 0 ? (filterData.region.length < 3 ? filterData.region.map(r => r.type === 'country' ? (countries.find(c => c.id == r.id_country)?.langtitle[activeLocale.code] ?? countries.find(c => c.id == r.id_country)?.title) : r.title).join(', ') : `${filterData.region.length} ${$t('regióny')}`) : filterData.country.map(c => c.langtitle[activeLocale.code] ?? c.title).join(', '))">

              </div>
              <div class="tt_ltp place-picker" v-if="activeElement==='place'">
                <template v-if="searchingPlace">
                  <PartsTempPreloader/>
                </template>


                <TopSearchPlaces :placeObj="placeObj" :searchingPlace="searchingPlace"
                                 :submitting="submitting" :activeLocale="activeLocale"
                                 :activeCountry="activeCountry" :places="places"
                                 @update:place="place = $event" ref="topSearchPlace"
                                 @update:placeObj="($p) => {placeObj = $p; place = null;filterStep = 'date'; activeElement = 'datePicker';}"
                                 @openAccommodation="openAccommodation"/>

                <div class="location-select" v-if=" ( place === null || place.length === 0 )">

                  <template v-if="filterStep === 'location.country'">
                    <LazyWidgetProductFilterProductFilterIndexFilterCountrySelect
                        :filterData="filterData" :countries="countries" :toggleMultiple="toggleMultiple"
                        @selectAction="searchStepAction"
                        :activeCountry="activeCountry" :activeLocale="activeLocale"/>
                  </template>

                  <RegionSelect :filterData="filterData" :countries="countries" :regions="regions"
                                @nextStep="searchStepAction" :activeLocale="activeLocale"
                                :toggleMultiple="toggleMultiple" v-if="filterStep === 'location.region'"/>

                </div>

                <div class="bottom" v-if=" ( place === null || place.length === 0 )">
                  <div class="d-flex justify-content-end">

                      <button class="btn btn-first btn-rounded"
                              @click="searchStepAction"
                              v-if="!searchingPlace">
                        {{ $t('continue') }}
                        {{ totalCounter > 0 ? `(${totalCounter})` : '' }}
                      </button>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-3 col-lg-3 col-xl-4 p-0 position-relative"
               :class="placeObj && placeObj.id > 0 ? '' : 'd-none d-lg-flex'">
            <div class="filter-item range" :class="activeElement==='datePicker' ? 'active' : ''">
              <div class="form-group" @click="setActiveElement('datePicker')">
                <label for="f_date">{{ $t('date-filter-title') }}</label>
                <input type="text" required name="date" id="f_date" class="form-control"
                       :placeholder="$t('date')" autocomplete="off" autocorrect="off" spellcheck="false"
                       ref="dateFromInput" :disabled="submitting"
                       aria-autocomplete="list"
                       :value="dateRange.startDate ? `${formattedDate(dateRange.startDate)} - ${formattedDate(dateRange.endDate)}` :''"
                       aria-expanded="false" @focus="activeElement = 'datePicker'">
              </div>

              <div class="tt_ltd py-3 px-4" v-if="activeElement === 'datePicker'">
                <LazyPartsCalendarRangePickerDouble
                    :minDate="(new Date()).setHours(0)"
                    :minDuration="1"
                    @onSelect="afterDateRangeSelect"
                />
              </div>
            </div>

          </div>

          <div class="col-12 col-md-2 col-lg-3 col-xl-3 p-0 position-relative"
               :class="dateRange.endDate !== null ? '' : 'd-none d-lg-flex'">
            <div class="filter-item hosts" :class="activeElement==='hosts' ? 'active' : ''">
              <div class="form-group" @click="setActiveElement('hosts')">

                <label for="hosts" class="text-capitalize">{{ $t('hosts') }}</label>
                <div class="input-group">
                  <input type="text" required name="hosts" id="hosts" class="form-control"
                         :disabled="submitting"
                         ref="hostsInput" autocomplete="off" autocorrect="off" spellcheck="false"
                         aria-autocomplete="list"
                         aria-expanded="false" :placeholder="$t('hosts-placeholder')"
                         @focus="setActiveElement('hosts')"
                         :value="hostsCount > 0 ? `${hostsCount} ${$t($vysklonujSlovo('host', hostsCount, 'ia', 'i')) }` : ''">

                </div>
              </div>

              <div class="tt_ltp py-3 px-4" v-if="activeElement==='hosts'">
                <LazyPartsHostsCountPicker @updateHosts="afterHostsChange" :initHosts="hosts"/>

                <button class="btn btn-outline-first float-end mt-3 rounded"
                        @click="activeElement = null" type="button">
                  {{ $t('confirm-choice') }}
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2 col-xl-1 pe-0">
            <div class="input-group-append d-none d-md-block">
              <div class="input-group-button">
                <button class="wide search btn-first float-end d-flex align-items-center"
                        @click="search">
                  <TyIcon icon="ty-search" color="white" width="1.3rem" height="1.3rem" class="me-1"/>
                  <span> {{ submitting ? ($t('searching')) : $t('search') }}</span>
                </button>
              </div>
            </div>
          </div>

          <div class="mobile col-12 d-lg-none mt-4 mb-3">
            <button class="btn btn-first rounded px-4" @click="search">
              <TyIcon :icon="'ty-search'" class="float-start icon-color-white" width="24px"/>
              <span class="bold ms-2">{{ submitting ? ($t('searching')) : $t('search') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import '~/assets/less/product_filter_index_desktop.min.css';
import {ref, watch} from "vue";
import dayjs from "dayjs";
import {useBaseFilter} from "~/composables/base_filter";
import {useStateFunctionBodyClass} from "../../../../../composables/state/body_class";
import {obtainActiveWebCountry, obtainActiveLocale} from "../../../../../composables/master_page";
import useStateAccommodationList from "../../../../../composables/state/accommodation_list";
import {clearObserverObj} from "../../../../../lib/functions";
import TopSearchPlaces from "./phone/top_search_places.vue";
import RegionSelect from "./index_filter_region_select.vue";
import {useNuxtApp} from "#app";

const activeElement = ref(null);
const placeInput = ref(null);
const dateFromInput = ref(null);
const hostsInput = ref(null);
const {updateBodyClass, removeBodyClass} = useStateFunctionBodyClass();
const {updateFilterData} = useStateAccommodationList();
const {$vysklonujSlovo} = useNuxtApp();

const hasActiveElement = () => {
  return activeElement.value !== null;
}
const activeLocale = obtainActiveLocale();
const activeCountry = obtainActiveWebCountry();
const topSearchPlace = ref(null);

const {
  place,
  searchPlace,
  submitting,
  searchBase,
  searchingPlace,
  placeObj,
  filterStep,
  totalCounter,
  countries,
  regions,
  places,
  dateRange,
  openAccommodation,
  hostsCount,
  hosts,
  toggleMultiple,
  toggleMultipleRegionCountry,
  filterData,
  listCountry,
  listRegions,
} = useBaseFilter();


watch(hasActiveElement, (val) => {
  if (val === true) {
    updateBodyClass('filter_active');
  } else {
    removeBodyClass('filter_active');
  }
})

const setActiveElement = (name) => {
  if (activeElement.value === name && name === 'place' && topSearchPlace.value) {
    topSearchPlace.value.focusCustomPlaceInput();
  }
  activeElement.value = name;
  if (name === 'place') {
    listCountry();
    filterStep.value = 'location.country';
  }
};

const search = () => {
  activeElement.value = null;
  submitting.value = true;
  searchBase();
}


const searchStepAction = () => {
  if (filterStep.value === 'location.country') {
    if (filterData.value.country.length > 0 && filterData.value.country[0].title !== 'Other') {
      filterStep.value = "location.region";
      filterData.value.region = [];
      listRegions(filterData.value.country);
    } else {
      filterStep.value = null;
      activeElement.value = null;
    }
  } else if (filterStep.value === 'location.region') {
    filterStep.value = null;
    if (dateRange.value.startDate === null) {
      activeElement.value = 'datePicker';
    } else {
      activeElement.value = null;
    }
  }
}

const disableActiveElement = () => {
  activeElement.value = null;
  searchingPlace.value = false;
}
const clearPlaces = () => {
  place.value = '';
  placeInput.value.focus();
  setTimeout(() => {
    activeElement.value = "place";
  }, 200);
}
const afterDateRangeSelect = (dateRangeT) => {
  dateRange.value = {startDate: dateRangeT.startDate, endDate: dateRangeT.endDate};
  setTimeout(() => {
    hostsInput.value.focus();
    activeElement.value = "hosts";
    updateFilterData({date: clearObserverObj(dateRange.value)});
  }, 200);
}

const afterHostsChange = (h) => {
  hosts.value = h;
  updateFilterData({hosts: h});
}
const formattedDate = (date) => {
  return dayjs(date).format('DD.MM.YYYY');
}
</script>
